import {
  am02ProductContent,
  dm02ProductContent,
  ds01ProductContent,
  pm02ProductContent,
} from './product-carousel.content';
import type { ProductLineupItem } from 'components/home/ProductLineup';

export const productLineupHeading = 'Whole-body benefits start here.';

export const productLineupBody =
  'Scientifically-studied formulations built for you and your microbiome.';

export const productLineupShopAll = { label: 'Shop All', url: '/products' };

const toLineupItem = (
  product: typeof ds01ProductContent,
  benefit: string,
): ProductLineupItem => ({
  sku: product.sku ?? '',
  benefit,
  url: product.primaryButton.url,
  media: product.media,
});

export const productLineupItems: ProductLineupItem[] = [
  toLineupItem(ds01ProductContent, 'Improves gut health°'),
  toLineupItem(dm02ProductContent, 'Helps fill nutrient gaps°'),
  toLineupItem(am02ProductContent, 'Combats brain fog°'),
  toLineupItem(pm02ProductContent, 'Promotes restful sleep°'),
];
